// Mock data for KJ Groundforce website

export const services = [
  {
    id: 1,
    title: "GROUNDWORKS & FOOTINGS",
    description: "Strong foundations for every project.",
    icon: "Shovel",
  },
  {
    id: 2,
    title: "FENCING & GATES",
    description: "Secure, durable and built to last.",
    icon: "Fence",
  },
  {
    id: 3,
    title: "LANDSCAPING",
    description: "Transforming gardens you'll love.",
    icon: "Trees",
  },
  {
    id: 4,
    title: "DRIVEWAYS",
    description: "Quality driveways built to impress.",
    icon: "Route",
  },
  {
    id: 5,
    title: "BLOCK PAVING & PATIOS",
    description: "Beautiful patios and paving solutions.",
    icon: "Grid3x3",
  },
  {
    id: 6,
    title: "DECKING",
    description: "Stylish, practical and built to last.",
    icon: "Layers",
  },
];

export const whyChooseUs = [
  {
    id: 1,
    title: "RELIABLE",
    description: "On time, every time.",
    icon: "ShieldCheck",
  },
  {
    id: 2,
    title: "PROFESSIONAL",
    description: "Skilled, experienced and fully insured.",
    icon: "BadgeCheck",
  },
  {
    id: 3,
    title: "QUALITY WORK",
    description: "Built to last, attention to detail.",
    icon: "Leaf",
  },
  {
    id: 4,
    title: "COMPETITIVE PRICES",
    description: "Great value without compromise.",
    icon: "PoundSterling",
  },
];

export const aboutFeatures = [
  {
    id: 1,
    title: "FULLY INSURED",
    description: "Peace of mind on every job.",
    icon: "ShieldCheck",
  },
  {
    id: 2,
    title: "LOCAL & TRUSTED",
    description: "Proudly serving your area.",
    icon: "MapPin",
  },
  {
    id: 3,
    title: "FREE QUOTES",
    description: "No obligation, honest advice.",
    icon: "PoundSterling",
  },
];

export const projects = [
  {
    id: 1,
    title: "SANDSTONE PATIO",
    category: "BLOCK PAVING",
    image: "https://images.unsplash.com/photo-1711098256664-d2ea62e6e376",
    large: true,
  },
  {
    id: 2,
    title: "HERRINGBONE DRIVEWAY",
    category: "DRIVEWAYS",
    image: "https://images.unsplash.com/photo-1612220626692-73acba353fcf",
    large: false,
  },
  {
    id: 3,
    title: "FEATHEREDGE FENCING",
    category: "FENCING",
    image: "https://images.unsplash.com/photo-1601042860368-debed90085e0",
    large: false,
  },
  {
    id: 4,
    title: "GARDEN DECKING",
    category: "DECKING",
    image: "https://images.pexels.com/photos/7587884/pexels-photo-7587884.jpeg",
    large: false,
  },
  {
    id: 5,
    title: "FULL GARDEN REBUILD",
    category: "LANDSCAPING",
    image: "https://images.unsplash.com/photo-1668120089662-42642838cfef",
    large: false,
  },
];

export const reviews = [
  {
    id: 1,
    name: "Sarah Thompson",
    location: "Derby",
    rating: 5,
    text: "Kyle and the team did an incredible job on our new driveway and front garden. Professional, tidy and finished on time. Couldn't recommend them more!",
  },
  {
    id: 2,
    name: "James Whitmore",
    location: "Nottingham",
    rating: 5,
    text: "Absolutely brilliant service from start to finish. The block paving looks stunning and the price was very fair. A true credit to their trade.",
  },
  {
    id: 3,
    name: "Emily Carter",
    location: "Leicester",
    rating: 5,
    text: "We had our entire garden landscaped and it exceeded our expectations. Kyle listened to what we wanted and delivered perfectly.",
  },
  {
    id: 4,
    name: "Mark Robinson",
    location: "Loughborough",
    rating: 5,
    text: "Fantastic workmanship on our new fence and gate. Reliable, hardworking and honest. Would definitely use again.",
  },
];

export const serviceAreas = [
  "Derbyshire",
  "Nottinghamshire",
  "Leicestershire",
  "Derby",
  "Nottingham",
  "Leicester",
  "Loughborough",
  "Long Eaton",
];

export const contactInfo = {
  phone: "07784 732546",
  email: "kyle33891@gmail.com",
  address: "Derbyshire, UK",
  hours: "Mon - Sat: 7:00 AM - 6:00 PM",
};
